'use es6';

export const pairs = ({
  metrics = []
}) => metrics.reduce((memo, {
  property,
  metricTypes: [metricType]
}) => [/* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
...memo, [property, metricType]], []);